export default {
  categories: [],
  category: undefined,
};
